<template>
  <form class="login-form">
    <b-field
      :message="getErrorMsgs('identification')"
      :type="{ 'is-danger': hasErrorMsgs('identification') }"
    >
      <b-input
        :disabled="hasIdentificationParam"
        :use-html5-validation="false"
        v-model="form.identification"
        class="identification-input"
        placeholder="請輸入統一編號"
        ref="identificationInput"
        type="number"
        @blur="v$.form.identification.$touch"
      />
    </b-field>
    <b-field
      :message="getErrorMsgs('account')"
      :type="{ 'is-danger': hasErrorMsgs('account') }"
    >
      <b-input
        :use-html5-validation="false"
        v-model="form.account"
        placeholder="請輸入登入帳號"
        type="text"
        @blur="v$.form.account.$touch"
      />
    </b-field>
    <b-field
      :message="getErrorMsgs('password')"
      :type="{ 'is-danger': hasErrorMsgs('password') }"
    >
      <b-input
        :use-html5-validation="false"
        v-model="form.password"
        password-reveal
        placeholder="請輸入密碼"
        type="password"
        @blur="v$.form.password.$touch"
      />
    </b-field>
    <div class="has-text-right">
      <b-button
        class="forget-password has-text-primary px-0"
        type="is-ghost"
        @click="toggleResetPwdModal(true)"
      >
        忘記密碼?
      </b-button>
    </div>
    <reset-password
      :open="resetPwdDialog"
      @close="toggleResetPwdModal(false)"
    />
    <b-button
      :disabled="v$.form.$invalid && v$.form.$dirty"
      :loading="logging"
      class="mt-large"
      expanded
      type="is-primary"
      @click="login"
    >
      登入
    </b-button>
  </form>
</template>

<script>
import LoginForm from './LoginForm';

export default LoginForm;
</script>

<style lang="scss" scoped>
@import 'LoginForm';
</style>
